// extracted by mini-css-extract-plugin
var _1 = "Borderless-moduleactive__wSH2N";
var _2 = "Borderless-moduleborderless__GzUz7";
var _3 = "Borderless-moduleicon___7ls2";
var _4 = "Borderless-moduleopened__bJdig";
export { _1 as "active", _2 as "borderless", _3 as "icon", _4 as "opened" }
